module.exports = __webpack_public_path__ + "img/health-guide-driving.da015991.png";